import { createFileRoute } from "@tanstack/react-router";

import SystemCatalogPage from "@/app/admin/system-catalog/SystemCatalogPage";

export const Route = createFileRoute("/admin/system-catalog")({
  component: SystemCatalogPage,
});
